import { render, staticRenderFns } from "./section-item.vue?vue&type=template&id=02640cf8&scoped=true"
import script from "./section-item.vue?vue&type=script&lang=ts"
export * from "./section-item.vue?vue&type=script&lang=ts"
import style0 from "../home-section.style.scss?vue&type=style&index=0&id=02640cf8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02640cf8",
  null
  
)

export default component.exports